import { useMantineColorScheme } from "@mantine/core";

/** Обычный iframe, но с поддержкой темной темы */
export const Iframe = function (
  props: React.IframeHTMLAttributes<HTMLIFrameElement>
) {
  const { colorScheme } = useMantineColorScheme();

  return (
    <iframe
      {...props}
      style={{
        border: 0,
        width: "100%",
        filter: colorScheme === "dark" ? "invert(1)" : "none",
        colorScheme: "light",
        ...props.style,
      }}
    />
  );
};
